<template>
<div class="profile-wrapper" v-if="user">
  <div class="profile">
    <div class="header">
      Tu perfil
    </div>
    <div class="verify" v-if="dataCompleted && !user.isLocked">
      <div class="verify-title">
        Estamos verificando tu información
      </div>
      <div class="verify-text">
        El equipo de Flagship se encuentra verificando tu información. Pronto podrás
        acceder a nuestros proyectos premium e invertir. No te preocupes, te enviaremos
        un correo electrónico cuando terminemos.
      </div>
    </div>
    <div class="verify green" v-else-if="dataCompleted && user.isLocked">
      <div class="verify-title">
        Cuenta verificada
      </div>
      <div class="verify-text">
        El equipo de Flagship ya ha verificado tu información. Ahora puedes ver
        nuestros proyectos premium así como, realizar inversiones. Si quieres
        realizar algún cambio en tu información envíanos un correo a support@flagship.mx
      </div>
      <div class="verify-action">
        <div class="verify-button" @click="goToProjects">
          Ir a proyectos
        </div>
      </div>
    </div>
    <div class="verify" v-else>
      <div class="verify-title">
        Verifica tu cuenta
      </div>
      <div class="verify-text">
        Ayúdanos a verificar tu cuenta proporcionándonos unos datos adicionales.
        El verificar tu cuenta te permite realizar inversiones así como, ver la
        información de los proyectos premium que se publiquen en la plataforma.
      </div>
      <div class="verify-action">
        <div class="verify-button" @click="$router.push('/wizard')">
          Verificar
        </div>
      </div>
    </div>
    <div class="account-data">
      <div
        class="user-image"
        :style="{ backgroundImage: `url('${user.profileImgUrl}')` }">
        <label class="label-file">
          <span class="mdi mdi-cloud-upload"></span>
          <input type="file" @change="uploadUserImage($event)">
        </label>
      </div>
      <div class="user">
        <div class="name">
          {{ user.name }} {{ user.lastName }}
        </div>
        <div class="user-info">
          <div class="user-label">Email</div>
          {{ user.email }}
        </div>
        <div class="user-info">
          <div class="user-label">Miembro desde</div>
          {{ moment(user.created_at).format('LL') }}
        </div>
      </div>
    </div>
    <div class="referral-data">
      <div class="referral-header">¡Obtén más inversión GRATIS!</div>
      <div class="referral-header" style="margin-top: 10px;">Saldo de referidos</div>
      <div class="balance">
        {{ formatMoney(user.referralBalance) }}
      </div>
      ¡Invita a invertir a tus amigos y añade más a tu inversión!
      <div class="verify-action">
        <div class="referral-button" @click="$router.push('/referral')">
          Aprende como
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import formatMixin from '@/mixins/formatMixin';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('user');
export default {
  data() {
    return {
      data: {},
      moment,
    };
  },
  mixins: [formatMixin],
  watch: {
    user() {
      this.data = { ...this.user };
    },
  },
  methods: {
    goToProjects() {
      window.location.replace('/#projects');
    },
    async uploadUserImage(event) {
      const fd = new FormData();
      const file = event.target.files[0];
      const url = `${process.env.VUE_APP_SERVER_URL}/public-upload`;
      fd.append('image', file);
      const fileLocation = await axios.post(url, fd);
      this.data.profileImgUrl = fileLocation.data.src;
      await this.updateUser(this.data);
    },
    ...mapActions([
      'updateUser',
    ]),
  },
  computed: {
    dataCompleted() {
      const keys = [
        'birthday',
        'curp',
        'workCompany',
        'nationality',
        'isPep',
        'isPepRelated',
        'officialIdUrl',
      ];

      for (let i = 0; i < keys.length; i += 1) {
        const element = keys[i];
        if (this.user[element] === null || this.user[element] === '') {
          return false;
        }
      }
      return true;
    },
    ...mapState([
      'user',
      'token',
    ]),
  },
  mounted() {
    moment.locale('es');
  },
};
</script>

<style lang="scss" scoped>
.profile-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #fafafa;
  font-family: 'Inter', sans-serif;
}
.profile {
  width: 900px;
  padding: 90px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.header {
  width: 100%;
  display: flex;
  padding: 15px 0;
  color: #202124;
  font-size: 28px;
  font-weight: bold;
}
.verify {
  width: 100%;
  padding: 30px 25px;
  border-radius: 8px;
  background-color: #e5ebfb;
  color: black;
  margin-top: 18px;
}
.green {
  background-color: #e6f5ee !important;

  .verify-button {
    background-color: #3fc67d;
  }
}
.verify-title {
  font-size: 28px;
  font-weight: bolder;
  margin-bottom: 16px;
}
.verify-text {
  font-size: 16px;
  line-height: 20px;
}
.verify-action {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.verify-button {
  background-color: #3479e9;
  color: white;
  padding: 12px 20px;
  display: flex;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}
.account-data {
  border: 1px solid #e8e8e8;
  padding: 30px;
  border-radius: 6px;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 65%;
}
.user-image {
  width: 20%;
  padding-bottom: 20%;
  background-size: cover;
  border-radius: 50%;
  background-color: rgb(221, 221, 221);
  margin-bottom: 40px;
  position: relative;
}
.user {
  width: 68%;
}
.name {
  font-weight: bolder;
  font-size: 32px;
}
.user-info {
  margin-top: 16px;
}
.user-label {
  color: rgb(177, 176, 176);
  margin-bottom: 5px;
}
.referral-data {
  width: 32%;
  border: 1px solid #e8e8e8;
  padding: 30px;
  margin-top: 30px;
  line-height: 1.5rem;
}
.referral-header {
  font-size: 18px;
  font-weight: bold;
}
.balance {
  font-weight: 500;
  font-size: 40px;
  margin-top: 30px;
  margin-bottom: 20px;
}
.referral-button {
  background-color: #3479e9;
  color: white;
  width: 100%;
  padding: 8px 0;
  display: flex;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.label-file {
  cursor: pointer;
  position: absolute;
  transform-origin: top left;
  bottom: -5px;
  right: -5px;
  white-space: nowrap;
  background-color: #3479e9;
  color: white;
  padding: 10px;
  border-radius: 50%;
  font-size: 20px;;
}
input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
@media only screen and (max-width: 500px) {
  .account-data {
    flex-direction: column;
  }
  .user-image {
    width: 30%;
    padding-bottom: 30%;
    margin-bottom: 30px;
  }
  .user {
    width: 100%;
  }
  .referral-data {
    width: 100%;
  }
  .account-data {
    width: 100%;
  }
}
</style>
